module.exports = __webpack_public_path__ + "static/broker-illustration-1c26b19a6beef4977f314699db454cb1.png";